import { useState } from "react";
import ContactTemplate from "./ContactTemplate";

const INITIAL_FORM = { name: "", email: "", company: "", message: "" };

export default function Contact() {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const apiUrl = process.env.NODE_ENV === 'development' 
        ? 'http://localhost:3001/api/send-contact'
        : '/api/send-contact';
      
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "A apărut o eroare. Încearcă din nou.");
        setLoading(false);
        return;
      }

      setSent(true);
      setFormData(INITIAL_FORM);
    } catch (err) {
      setError("Eroare de conexiune. Încearcă din nou.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContactTemplate
      formData={formData}
      sent={sent}
      onChange={handleChange}
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
    />
  );
}
